const initialState = {}
const filter = { 
  sort: { time: 'asc' },
  hideHappening: false,
  hideEnded: false,
  hideConfirmed: false,
  hideSeen: false,
  hideNotDeclined: false,
  hideToDoComplete: false,
  fakesOff: false,
  newFacilities: false,
  confirmedWithFacility: false,
  requiresCaptain: false,
  hasCaptain: false,
  missingCaptain: false,
  fullWithFakes: false,
  lowRating: false,
  hidingOptions: function() { return [
    this.hideHappening, this.hideEnded, this.hideConfirmed, this.hideSeen, this.hideNotDeclined, this.hideToDoComplete, 
    this.fakesOff, this.newFacilities, this.confirmedWithFacility, this.requiresCaptain, this.hasCaptain, 
    this.missingCaptain, this.fullWithFakes, this.lowRating
  ] },
  isDisabled: function() { return this.hidingOptions().every(x => !x) }
}
const gamesSelector = { 
  enabled: false,
  selected: [],
  action: null
}

const updatedEvents = (state, gameId, params) => {
  const gameIndex = state.events.findIndex((event) => { return event.id == gameId })
  if (gameIndex == -1) return state.events

  let newGameEvent = { ...state.events[gameIndex], ...params }
  return [
    ...state.events.slice(0, gameIndex), 
    newGameEvent,
    ...state.events.slice(gameIndex + 1, state.events.length)
  ]
}

const appendedEvents = (state, params) => {
  return [ params, ...state.events ]
}

const releasedEvents = (state, gameId) => {
  const gameIndex = state.events.findIndex((event) => { return event.id == gameId })
  return [
    ...state.events.slice(0, gameIndex), 
    ...state.events.slice(gameIndex + 1, state.events.length)
  ]
}

const appendSelectedId = (state, payload) => {
  if (!payload.id) return payload

  const selected = state.gamesSelector.selected
  const newSelected = selected.indexOf(payload.id) == -1 ? selected.concat(payload.id) : selected.filter(e => e !== payload.id)
  return {...state.gamesSelector, selected: newSelected}
}

const openGames = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'OPEN_GAMES.INIT':
      return {...state, ...payload, query: '', cancelled: false, upcoming: false, alert: null, 
        filter: filter, unseen: [], gameNotifications: [], gamesSelector: gamesSelector}
    case 'OPEN_GAMES.QUERY':
      return {...state, query: payload}
    case 'OPEN_GAMES.CANCELLED':
      return {...state, cancelled: payload}
    case 'OPEN_GAMES.RECEIVED':
      return {...state, ...payload, upcoming: false, isLoading: false}
    case 'OPEN_GAMES.UPCOMING_RECEIVED':
      return {...state, ...payload, upcoming: true, isLoading: false}
    case 'OPEN_GAMES.TODO_CHANGE':
      const newEvents = [
        ...state.events.slice(0, payload.eventIndex), 
        { ...state.events[payload.eventIndex], todos_done_count: payload.newDoneCount },
        ...state.events.slice(payload.eventIndex + 1, state.events.length)
      ]
      return {...state, events: newEvents}
    case 'OPEN_GAMES.GAME_UPDATE':
      let gameParams = {}
      let newSummary = Object.assign({}, state.summary)
      if ('max_players' in payload || 'players_count' in payload) {
        gameParams.total_spots = payload.max_players
        gameParams.number_of_players = payload.players_count
        gameParams.spots_remaining = payload.max_players - payload.players_count
      }
      if ('players_join' in payload) newSummary.total_players = newSummary.total_players + payload.players_join
      if ('players_leave' in payload) newSummary.total_players = newSummary.total_players - payload.players_leave
      if ('confirmed' in payload) gameParams.confirmed = payload.confirmed
      if ('notes_count' in payload) gameParams.notes = payload.notes_count > 0
      if ('channel_id' in payload) gameParams.channel_id = payload.channel_id
      if ('fakes_count' in payload) gameParams.number_of_fakes = payload.fakes_count
      if ('has_captain' in payload) gameParams.has_captain = payload.has_captain

      return {...state, summary: newSummary, events: updatedEvents(state, payload.game_id, gameParams)}
    case 'OPEN_GAMES.GAME_PAYMENT_STATUS':
      if (_.isEmpty(state)) return state
      
      const index = state.events.findIndex((event) => { return event.id == payload.game_id })
      if (index == -1) return state
    
      const declined = state.events[index].declined
      let newDeclined = []
      if (payload.success)
        newDeclined = declined.filter(function(item) { return item !== payload.player_reservation_id })
      else
        newDeclined = declined.concat(payload.player_reservation_id)

      return {...state, events: updatedEvents(state, payload.game_id, { declined: newDeclined })}
    case 'OPEN_GAMES.ADD_GAME':
      const appendedSummary = {total_events: state.summary.total_events + 1, total_hours: state.summary.total_hours + payload.duration }
      return {...state, events: appendedEvents(state, payload), summary: appendedSummary}
    case 'OPEN_GAMES.REMOVE_GAME':
      const releasedSummary = {total_events: state.summary.total_events - 1, total_hours: state.summary.total_hours - payload.duration }
      return {...state, events: releasedEvents(state, payload), summary: releasedSummary}
    case 'OPEN_GAMES.UPDATE_GAME':
      return {...state, events: updatedEvents(state, payload.id, payload)}
    case 'OPEN_GAMES.END_SELECTOR':
      return {...state, ...payload, gamesSelector: gamesSelector}
    case 'OPEN_GAMES.CLEAR_ALERT':
      if (_.isEmpty(state)) return state

      return {...state, alert: null}
    case 'OPEN_GAMES.SET_ALERT':
      return {...state, alert: payload}
    case 'OPEN_GAMES.SET_FILTER':
      return {...state, filter: payload}
    case 'OPEN_GAMES.SET_UNSEEN':
      return {...state, unseen: payload.channels}
    case 'OPEN_GAMES.SET_GAME_NOTIFICATIONS':
      return {...state, gameNotifications: payload.gameNotifications}
    case 'OPEN_GAMES.GAMES_SELECTOR':
      return {...state, gamesSelector: appendSelectedId(state, payload)}
    case 'OPEN_GAMES.SET_LOADING':
      return {...state, isLoading: true}
    default:
      return state
  }
}

export default openGames
